import { useCallback } from 'react';

function generateSessionID(): string {
  // A simple unique ID generator; replace with a more robust solution if needed.
  return 'sess_' + Math.random().toString(36).substring(2, 11);
}

// Extend the global Window interface to include "Hyper"
declare global {
  interface Window {
    Hyper?: (
      str: string,
      option: { customBackendUrl?: string } | null,
      analyticsObj: { sessionID: string; timeStamp: string }
    ) => any;
  }
}

export const useHyperswitchLoader = () => {
  const loadHyper = useCallback(
    (str: string, option: { customBackendUrl?: string } | null) => {
      return new Promise((resolve, reject) => {
        if (typeof document === 'undefined') {
          reject(new Error('document is not defined'));
          return;
        }

        const sessionID = generateSessionID();
        const timeStamp = Date.now();
        const scriptURL = `/assets/hyperswitch/HyperLoader.js`;

        const analyticsObj = {
          sessionID,
          timeStamp: String(timeStamp),
        };

        if (document.querySelectorAll(`script[src="${scriptURL}"]`).length === 0) {
          const script = document.createElement('script');
          script.src = scriptURL;
          script.onload = () => {
            if (window.Hyper) {
              // Assuming window.Hyper is a function expecting (str, option, analyticsObj)
              resolve(window.Hyper(str, option, analyticsObj));
            } else {
              reject(new Error('Hyper is not available on the window object.'));
            }
          };
          script.onerror = (err) => {
            reject(err);
          };
          document.body.appendChild(script);
          return;
        }

        console.warn(
          `INTEGRATION WARNING: There is already an existing script tag for ${scriptURL}. Multiple additions of HyperLoader.js is not permitted, please add it on the top level only once.`
        );
        if (window.Hyper) {
          resolve(window.Hyper(str, option, analyticsObj));
        } else {
          reject(new Error('Hyper is not available on the window object.'));
        }
      });
    },
    []
  );

  return { loadHyper };
};

export default useHyperswitchLoader;